export class ChoixFormulaireMessages {

  public libelleCritere = 'choixFormulaire.libelleCritere';
  public libelleChoix = 'choixFormulaire.libelleChoix';
  public requisA = 'general.requisA';
  public requisB = 'general.requisB';
  public typeOrganisme = 'choixFormulaire.typeOrganisme';
  public resetFields = 'choixFormulaire.resetFields';
  public search = 'choixFormulaire.search';


  constructor() {
  }
}
